var collectionTitleOffsetHeightList = []

function scrollMenuInit(options){
    var slidesPerView = 3;
    var width = $(window).width()
    if(width < 768){
        console.log(options.slidesPerView.xs)
        slidesPerView = options.slidesPerView.xs ? options.slidesPerView.xs : 3;
    }else if(width < 1200){
        console.log(options.slidesPerView.md)
        slidesPerView = options.slidesPerView.md || 4;
    }else{
        //>1200
        slidesPerView = options.slidesPerView.lg || 5;
    }
    var containerQuery = options.container ? options.container : ".swiper-container"
    var swiper = new Swiper(containerQuery, {
        // pagination: '.swiper-pagination',
        slidesPerView: slidesPerView,
        // centeredSlides: true,
        paginationClickable: true,
        spaceBetween: 0,
        freeMode: true,
        prevButton:'.swiper-right',
        nextButton:'.swiper-left',
    });
    var titleListFixed = false;
    var offsetTop = $(".collection-title-list").offset().top;
    $(".container-point").each(function(){
        collectionTitleOffsetHeightList.push(Math.floor($(this).offset().top))
    })
//     console.log(collectionTitleOffsetHeightList);
    var lastHeight = $(".scroll-block .container").last().height();
    var lastScroll = collectionTitleOffsetHeightList[collectionTitleOffsetHeightList.length-1] + lastHeight;
    collectionTitleOffsetHeightList.push(lastScroll)
    var sliderCurrentIndex = 0;
    $(document).scroll(function(){
        var scrollHeight = $(document).scrollTop()
        var headerStickyHeight = $(".header__wrapper").height()
        if(scrollHeight > offsetTop && !titleListFixed){
            $(".collection-title-list").addClass("collection-title-fixed");
            $(".my-discount-time").addClass("countdown-fixed");
            $(".collection-title-list").css({
                top:headerStickyHeight+"px"
            })
            titleListFixed = true;
        }else if( scrollHeight < offsetTop && titleListFixed){
            $(".collection-title-list").removeClass("collection-title-fixed");
            $(".my-discount-time").removeClass("countdown-fixed");
            $(".collection-title-list").css({
                top:headerStickyHeight+"px"
            })
            titleListFixed = false;
        }
        var index = getSliderIndex(collectionTitleOffsetHeightList,scrollHeight);
        if(sliderCurrentIndex != index){
            swiper.slideTo(index)
            sliderCurrentIndex = index;
            $(".collection-title-list .title-item").each(function(){
                $(this).removeClass("active")
            })
            $(".collection-title-list .title-item:eq(" + index + ")").addClass("active");
        }
    })
    $(".collection-title-list .title-item").click(function(){
        $(".collection-title-list .title-item").each(function(){
            $(this).removeClass("active")
        })
        $(this).addClass("active");
      	var hrefDom = $(this).attr('href');
        var headerStickyHeight = $(".header__wrapper").height();
      	var offsetTop = $(hrefDom).offset().top-headerStickyHeight-70;
        $("html,body").animate({scrollTop:offsetTop},1000)
//       	console.log(offsetTop);
//       	var index = getSliderIndex(collectionTitleOffsetHeightList,offsetTop);
//       	swiper.slideTo(index);
    })
}
function getSliderIndex(data,scrollHeight){
    var currentIndex = 0;
    for(var i=0;i<data.length;i++){
        if(scrollHeight + $(window).height()*0.5 < data[i] ){
            currentIndex = i;
            break
        }
    }
    var last = data[data.length-1];
    if(scrollHeight > last){
        return data.length - 1
    }
    if(currentIndex == 0){
        return currentIndex;
    }else{
        return currentIndex - 1;
    }
}
function updateCollectionOffsetHeightList(){
    $(".container-point").each(function(){
        collectionTitleOffsetHeightList.push(Math.floor($(this).offset().top))
    })
    var lastHeight = $(".scroll-block .container").last().height();
    var lastScroll = collectionTitleOffsetHeightList[collectionTitleOffsetHeightList.length-1] + lastHeight;
    collectionTitleOffsetHeightList.push(lastScroll)
}